import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import { ProductsPage } from './ProductsPage';
import { ProductFormPage } from './ProductFormPage';
import { ProductDetailPage } from './ProductDetailPage';
import { ProductCategoriesPage } from './ProductCategoriesPage';
import { ProductBookingGroupsPage } from './ProductBookingGroupsPage';
import { ProductUnitsPage } from './ProductUnitsPage';
import { ProductTagsPage } from './ProductTagsPage';
import type { BackofficeModule } from '../registry';

/**
 * Einstiegspunkt des Moduls „Produkte“ im Backoffice (KON-107). Alles dazu liegt in diesem Ordner. Das Backoffice kennt nur diese Datei (siehe registry.tsx).
 * Die Verträge zur API stehen in packages/shared/src/products.
 */
export const productsModule: BackofficeModule = {
  key: 'products',
  path: '/produkte',
  // Kategorien, Einheiten und Tags pflegt der Mandant in der Einrichtung unter „Produkte“, sie setzen das lizenzierte Modul voraus
  setupSections: [
    {
      path: 'produktkategorien',
      label: 'Kategorien',
      module: 'setup',
      permission: 'setup.read',
      requires: 'products',
      description: 'Haupt- und Unterkategorien für Ihre Produkte, zum Beispiel Möbel mit Stühlen und Tischen.',
      built: true,
      group: 'products',
      keywords: ['Kategorie', 'Unterkategorie', 'Warengruppe', 'Sortiment'],
    },
    {
      path: 'einheiten',
      label: 'Einheiten',
      module: 'setup',
      permission: 'setup.read',
      requires: 'products',
      description: 'Einheiten mit Kürzel, zum Beispiel Stück (Stk.), Stunde (Std.) oder Quadratmeter (m²). Das Kürzel erscheint im Angebot.',
      built: true,
      group: 'products',
      keywords: ['Stück', 'Stunde', 'Mengeneinheit', 'Kürzel', 'Maßeinheit'],
    },
    {
      path: 'buchungsgruppen',
      label: 'Buchungsgruppen',
      module: 'setup',
      permission: 'setup.read',
      requires: 'products',
      description: 'Welches Sachkonto beim Buchen gilt: Jedes Produkt gehört zu einer Gruppe, und die Gruppe nennt das Konto, das Ihr Steuerberater festlegt. Auch für Gutscheine.',
      built: true,
      group: 'products',
      keywords: ['Sachkonto', 'Erlöskonto', 'Konto', 'Gutschein', 'Verbindlichkeit', 'Buchung', 'Steuerberater', 'Produktbuchungsgruppe'],
    },
    {
      path: 'produkt-tags',
      label: 'Tags',
      module: 'setup',
      permission: 'setup.read',
      requires: 'products',
      description: 'Schlagwörter mit Farbe für Produkte, zum Beispiel Neuheit oder Saisonware. Die Produktliste filtert danach.',
      built: true,
      group: 'products',
      keywords: ['Schlagwort', 'Etikett', 'Label', 'Markierung'],
    },
  ],
  setupRoutes: (
    <>
      <Route path="produktkategorien" element={<ModuleGate module="setup" permission="setup.read"><ProductCategoriesPage /></ModuleGate>} />
      <Route path="einheiten" element={<ModuleGate module="setup" permission="setup.read"><ProductUnitsPage /></ModuleGate>} />
      <Route path="buchungsgruppen" element={<ModuleGate module="setup" permission="setup.read"><ProductBookingGroupsPage /></ModuleGate>} />
      <Route path="produkt-tags" element={<ModuleGate module="setup" permission="setup.read"><ProductTagsPage /></ModuleGate>} />
    </>
  ),
  routes: (
    <>
      <Route path="produkte" element={<ModuleGate module="products" permission="products.read"><ProductsPage /></ModuleGate>} />
      <Route path="produkte/neu" element={<ModuleGate module="products" permission="products.write"><ProductFormPage /></ModuleGate>} />
      <Route path="produkte/:id" element={<ModuleGate module="products" permission="products.read"><ProductDetailPage /></ModuleGate>} />
      <Route path="produkte/:id/bearbeiten" element={<ModuleGate module="products" permission="products.write"><ProductFormPage /></ModuleGate>} />
    </>
  ),
};
